<template>
    <div class="sfClock">
        <div class="back_icon"
             @click="goBack"></div>
        <div class="title"
             v-if="unit_list.length">选择班级</div>
        <div class="unit_list"
             v-if="unit_list.length">
            <div class="tips">请选择您想要查看的书法班级圈</div>
            <div class="unit_item"
                 v-for="(item,index) in unit_list"
                 @click="handleJump(item)"
                 :key="index">{{item.unit_name}}</div>
        </div>
        <div class="no_open"
             v-else>
            <img class="no_icon"
                 src="./img/img_icon_02.png"
                 alt="">
            <div class="no_tips">你所在的年级<br /><span class="orange">还未开启</span>书法班级圈</div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            unit_list: []
        }
    },
    created () {
        this.getUnit()
    },
    methods: {
        handleJump (item) {
            this.$router.push('/activity/sf_clock/home/' + item.unit_class_id)
        },
        goBack () {
            if (this.inApp) {
                this.appFunction("ys_finish", "", 1)
            } else {
                this.$router.go(-1);
            }
        },
        getUnit () {
            this.$http.post(API_URL_HD_API + '/sf_clock/tea/units/',).then((res) => {
                res = res.data;
                if (res.response === 'ok') {
                    this.unit_list = res.data
                } else {
                    layer.tips(res.message);
                }
            })
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.sfClock {
    min-height: 100vh;
    background-color: #fff;
    position: relative;
    .back_icon {
        position: absolute;
        height: 96px / $ppr;
        width: 84px / $ppr;
        top: 0;
        left: 0;
        background-size: 21px / $ppr 35px / $ppr;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url("./img/img_icon_01.png");
        z-index: 9;
    }
    .title {
        position: absolute;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        width: 100%;
        top: 0;
        left: 0;
        text-align: center;
        font-size: 30px / $ppr;
        font-weight: bold;
        z-index: 2;
    }
    .unit_list {
        position: absolute;
        top: 20%;
        left: 0;
        width: 100%;
        .tips {
            text-align: center;
            font-size: 30px / $ppr;
            font-weight: bold;
            margin-bottom: 64px / $ppr;
        }
        .unit_item {
            width: 272px / $ppr;
            height: 60px / $ppr;
            line-height: 60px / $ppr;
            text-align: center;
            background: #5dc47c;
            border-radius: 30px / $ppr;
            display: block;
            margin: 24px / $ppr auto;
            color: #fff;
            font-weight: bold;
        }
    }
    .no_open {
        position: absolute;
        top: 45%;
        left: 0;
        width: 100%;
        transform: translateY(-50%);
        .no_icon {
            display: block;
            width: 298px / $ppr;
            margin: 0 auto 32px / $ppr;
        }
        .no_tips {
            text-align: center;
            font-size: 32px / $ppr;
            line-height: 48px / $ppr;
            .orange {
                color: #e07962;
            }
        }
    }
}
</style>